export default __webpack_public_path__ + "static/media/circuitoLogo.2629ffb0.png";